module.exports = __webpack_public_path__ + "img/5.45bb4b94.jpg";